<template>
  <li role="presentation" :class="activeClass">
    <a
      :href="href"
      :aria-controls="ariaControls"
      role="tab"
      data-toggle="tab"
      @click="$emit('click', title)"
    >
      {{title}}
    </a>
  </li>
</template>

<script>
export default {
  name: "nav-tab",
  props: {
    active: {
      type: Boolean,
      default: false
    },
    href: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    ariaControls: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    activeClass() {
      return this.active ? "active" : "";
    }
  }
};
</script>

<style scoped>
a[data-toggle="tab"] {
  font-weight: 700;
}
</style>



// WEBPACK FOOTER //
// src/components/UIComponents/Tabs/NavTab.vue